import { t } from '@lingui/macro';
import React from 'react';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import { LegendRenderer } from '../../LegendRenderer';
import { AGGREGATED_FINISHES_AUGUST_GRADIENT_LEGEND } from '../../../constants/legends';

// Выбор года вынесен на таймлайн внизу карты (AggFinishesAugustYearTimeline).
// Здесь остаётся только легенда.
const AggFinishesFilterComponent = () => (
    <div>
        <LegendRenderer config={AGGREGATED_FINISHES_AUGUST_GRADIENT_LEGEND} />
    </div>
);

export const AggFinishAugustFilter = withDisplayedLayersCheck(
    AggFinishesFilterComponent,
    t`Агрегированные финиши (август)`
);
